import { createFileRoute } from "@tanstack/react-router";
import PartsAccountLayout from "@/pages/parts-account/PartsAccountLayout";

export const Route = createFileRoute("/_partsAuth")({
  component: () => <PartsAccountLayout />,
});
